// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * color scheme: https://color.adobe.com/create/color-wheel/?base=2&rule=Complementary&selected=4&name=My%20Color%20Theme&mode=rgb&rgbvalues=0.17030891601918655,0.4058823529411765,0.023676470588235302,0.5171907756812364,1,0.21666666666666667,0.3215686274509804,0.7058823529411765,0.08235294117647059,0.39483604076295736,0,0.4058823529411765,0.6889126559717383,0.08235294117647061,0.7058823529411765&swatchOrder=0,1,2,3,4
 */
:root {
  --button-color: #555555;
  --button-color-hover: #333333;
  --button-color-inactive: #E0E0E0;

  --loader-color: #404040;

  --link-color: #0e9663;
  --link-color-hover: #075035;

  --bpmnio-color: #10ad73;

  --alert-width: 450px;
  --dialog-width: 600px;
}
`, "",{"version":3,"sources":["webpack://./client/css/variables.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;;EAEhC,uBAAuB;;EAEvB,qBAAqB;EACrB,2BAA2B;;EAE3B,uBAAuB;;EAEvB,oBAAoB;EACpB,qBAAqB;AACvB","sourcesContent":["/**\n * color scheme: https://color.adobe.com/create/color-wheel/?base=2&rule=Complementary&selected=4&name=My%20Color%20Theme&mode=rgb&rgbvalues=0.17030891601918655,0.4058823529411765,0.023676470588235302,0.5171907756812364,1,0.21666666666666667,0.3215686274509804,0.7058823529411765,0.08235294117647059,0.39483604076295736,0,0.4058823529411765,0.6889126559717383,0.08235294117647061,0.7058823529411765&swatchOrder=0,1,2,3,4\n */\n:root {\n  --button-color: #555555;\n  --button-color-hover: #333333;\n  --button-color-inactive: #E0E0E0;\n\n  --loader-color: #404040;\n\n  --link-color: #0e9663;\n  --link-color-hover: #075035;\n\n  --bpmnio-color: #10ad73;\n\n  --alert-width: 450px;\n  --dialog-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
